import { render, staticRenderFns } from "./EditArticle.vue?vue&type=template&id=26415f9a&scoped=true&"
import script from "./EditArticle.vue?vue&type=script&lang=js&"
export * from "./EditArticle.vue?vue&type=script&lang=js&"
import style0 from "./EditArticle.vue?vue&type=style&index=0&id=26415f9a&lang=scss&scoped=true&"
import style1 from "./EditArticle.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26415f9a",
  null
  
)

export default component.exports